import script from "./BoardState.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoardState.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__